import React, {FC} from "react";
import {OrderAddress} from "../../redux/types";
import {LabeledTextDisplay} from "../../../../sharedComponents/LabeledTextDisplay";
import {getFullName} from "../../../../utils";
import {AddressDisplay} from "../../../../sharedComponents/AddressDisplay";
import {makeStyles} from "@material-ui/core/styles";
import {Divider, IconButton, Typography} from "@material-ui/core";
import {EditOutlined as EditIcon} from "@material-ui/icons";
import {useHistory, useRouteMatch} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    spacingBottom: {
        marginBottom: theme.spacing(2)
    }
}));

interface OrderAddressDisplayProps {
    value?: OrderAddress;
    isInvoice?: boolean;
    className?: string;
    editIdentifier: string;
}

export const OrderAddressDisplay: FC<OrderAddressDisplayProps> = ({value, isInvoice, className, editIdentifier}) => {
    const classes = useStyles();
    const history = useHistory();
    const {url} = useRouteMatch();
    return (
        <div className={className}>
            <Typography
                variant="body1"
                color="primary"
            >
                {isInvoice ? "Rechnungsadresse" :  "Auftragsadresse"}
                {editIdentifier && (
                    <IconButton
                        size="small"
                        onClick={() => history.replace(`${url}?mode=edit#${editIdentifier}`)}
                    >
                        <EditIcon fontSize="inherit"/>
                    </IconButton>
                )}
            </Typography>
            <Divider className={classes.spacingBottom}/>
            <LabeledTextDisplay
                label={"Name"}
                required={!isInvoice}
                value={value ? getFullName(value.name) : undefined}
                className={classes.spacingBottom}
            />
            <LabeledTextDisplay
                label={"Telefon"}
                required={!isInvoice}
                value={value?.phone}
                className={classes.spacingBottom}
            />
            <AddressDisplay
                loading={!value}
                address={value?.address?.formattedAddress}
            />
        </div>
    )
}
